/* eslint-disable no-unused-vars */
import bus from '@/utils/bus';
import Vue from 'vue';
import Router from 'vue-router';
import multiguard from 'vue-router-multiguard';

Vue.use(Router);

function load(component) {
  return () => import(`@/views/${component}.vue`);
}

const alreadyLoggedIn = (to, from, next) => {
  if (Vue.cookies.get('sctoken')) {
    next({ name: 'Home' });
  } else {
    next();
  }
};

const isLogged = (to, from, next) => {
  const token = Vue.cookies.get('sctoken');

  if (to.path.includes('/issue/')) {
    sessionStorage.setItem('redirectPath', to.path);
  }

  if (token) {
    next();
  } else {
    next({ name: 'login' });
  }
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [
    //welcome routes of NEO integration
    {
      path: '/integracao',
      component: load('Integracao'),
      name: 'integracao',
      children: [
        {
          path: 'neo',
          name: 'neo',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginNeo')
        },
        {
          path: 'isp',
          name: 'isp',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginIsp')
        },
        {
          path: 'faq',
          name: 'Faq',
          component: load('Faq'),
          meta: {
            backArrow: true,
            title: 'profile.faq'
          }
        },
        {
          path: 'terms-of-use',
          name: 'Termos',
          component: load('Termos'),
          meta: {
            backArrow: true,
            title: 'text.termsOfUse'
          }
        },
        {
          path: 'privacy-policies',
          name: 'Politica',
          component: load('Politica'),
          meta: {
            backArrow: true,
            title: 'text.privacyPolicy'
          }
        },
        {
          path: 'redirect-app',
          name: 'RedirectApp',
          component: load('RedirectApp'),
          meta: {
            backArrow: true,
            title: 'text.redirect-app'
          }
        }
      ]
    },

    {
      path: '/logout',
      name: 'logout',
      component: load('Logout')
    },

    //welcome routes
    {
      path: '/welcome',
      component: load('Welcome'),
      name: 'welcome',
      redirect: { name: 'login' },
      children: [
        {
          path: 'skeelo',
          name: 'Skeelo',
          component: load('Skeelo'),
          meta: {
            title: 'Skeelo'
          }
        },
        {
          path: 'login',
          name: 'login',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('Login')
        },
        {
          path: 'regions/:regionId/partners',
          name: 'partners',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginParceiros')
        },
        {
          path: 'login/:regionId',
          name: 'loginPhone',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginPhone')
        },
        {
          path: 'regions/:regionId/partners/:id',
          name: 'partnerLogin',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginDinamico'),
          meta: {
            backArrow: true
          }
        },
        {
          path: 'sercomtel',
          name: 'sercomtel',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginSercomtel')
        },
        {
          path: 'monetolab',
          name: 'monetolab',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginMonetoLab')
        },
        {
          path: 'tpnet',
          name: 'tpnet',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginTpnet')
        },
        {
          path: 'azul',
          name: 'azul',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginAzul')
        },
        {
          path: 'venezuela',
          name: 'venezuela',
          beforeEnter: multiguard([alreadyLoggedIn]),
          component: load('LoginVenezuela')
        },
        {
          path: 'categories',
          name: 'Categorias',
          component: load('Categorias'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'faq',
          name: 'Faq',
          component: load('Faq'),
          meta: {
            backArrow: true,
            title: 'profile.faq'
          }
        },
        {
          path: 'terms-of-use',
          name: 'Termos',
          component: load('Termos'),
          meta: {
            backArrow: true,
            title: 'text.termsOfUse'
          }
        },
        {
          path: 'privacy-policies',
          name: 'Politica',
          component: load('Politica'),
          meta: {
            backArrow: true,
            title: 'text.privacyPolicy'
          }
        }
      ]
    },

    {
      path: '/',
      component: load('Layout'),
      name: 'Layout',
      beforeEnter: multiguard([isLogged]),
      children: [
        {
          path: 'home',
          alias: '/',
          name: 'Home',
          component: load('Home'),
          meta: {
            backArrow: false,
            title: 'Super Comics'
          }
        },
        {
          path: 'coquetel',
          alias: '/',
          name: 'coquetel',
          component: load('TesteCoquetel'),
          meta: {
            backArrow: false,
            title: 'Coquetel'
          }
        },
        {
          path: 'subscription',
          name: 'Subscription',
          component: load('Subscription'),
          meta: {
            requireAuth: true,
            backArrow: true,
            title: 'Super Comics'
          }
        },
        {
          path: 'recomended-for-you',
          name: 'Recomended',
          component: load('Playlist'),
          meta: {
            requireAuth: true,
            backArrow: true,
            title: 'title.recommended',
            type: 'Recomended'
          }
        },
        {
          path: 'news',
          name: 'News',
          component: load('Playlist'),
          meta: {
            requireAuth: true,
            backArrow: true,
            title: 'title.news',
            type: 'News'
          }
        },
        {
          path: 'download',
          name: 'Download',
          component: load('Playlist'),
          meta: {
            requireAuth: true,
            backArrow: true,
            title: 'profile.download',
            type: 'Download'
          }
        },
        {
          path: 'popular-this-week',
          name: 'Popular',
          component: load('Playlist'),
          meta: {
            requireAuth: true,
            backArrow: true,
            title: 'title.highlights',
            type: 'Popular'
          }
        },
        {
          path: 'search/:term?',
          name: 'Busca',
          component: load('Busca'),
          meta: {
            header: false,
            backArrow: false,
            title: 'title.Search'
          }
        },
        {
          path: 'explore',
          name: 'Explorar',
          component: load('Explorar'),
          meta: {
            backArrow: false,
            title: 'title.Explore'
          }
        },
        {
          path: 'child',
          name: 'ExplorarChild',
          component: load('Categoria'),
          meta: {
            backArrow: false,
            title: 'title.Categories'
          }
        },
        {
          path: 'explore/category/:categoryId/:categoryName?',
          name: 'Categoria',
          component: load('Categoria'),
          meta: {
            backArrow: true,
            title: 'title.Categories'
          }
        },
        {
          path: 'title/:titleId',
          name: 'Titulo',
          component: load('Titulo'),
          meta: {
            backArrow: true,
            title: 'title.Titles'
          }
        },
        {
          path: 'issue/:issueId',
          alias: '/:lang/i/:issueId',
          name: 'Edicao',
          component: load('Edicao'),
          meta: {
            backArrow: true,
            title: 'text.Edition'
          }
        },
        {
          path: 'issue/image/:issueId/page/:pageNumber',
          name: 'EdicaoImage',
          component: load('EdicaoImage'),
          meta: {
            drawer: false,
            toolbarMobile: false,
            footerMobile: false,
            backArrow: false,
            title: 'text.Edition'
          }
        },
        {
          path: 'issue/video/:issueId/page/:pageNumber?',
          name: 'EdicaoVideo',
          component: load('EdicaoVideo'),
          meta: {
            drawer: false,
            toolbarMobile: false,
            footerMobile: false,
            backArrow: false,
            title: 'text.Edition'
          }
        },
        {
          path: 'playlist/:playlistId',
          name: 'Playlist',
          component: load('Playlist'),
          meta: {
            type: 'Playlist',
            backArrow: true,
            title: 'Playlist'
          }
        },
        {
          path: 'favorites',
          name: 'Favoritos',
          component: load('Favoritos'),
          meta: {
            backArrow: false,
            title: 'title.favorites'
          }
        },
        {
          path: 'profile',
          name: 'Perfil',
          component: load('Perfil'),
          meta: {
            backArrow: false,
            title: 'title.profile'
          },

          children: [
            {
              path: 'profile/editar',
              alias: 'profileEditar',
              name: 'PerfilEditar',
              component: load('PerfilEditar'),
              meta: {
                backArrow: true,
                title: 'title.editProfile'
              }
            },
            {
              path: 'profile/editar-fone',
              name: 'PerfilEditarFone',
              component: load('PerfilEditarFone'),
              meta: {
                backArrow: true,
                title: 'profile.editPhone'
              }
            },
            {
              path: 'profile/infantil',
              name: 'PerfilInfantil',
              component: load('PerfilInfantil'),
              meta: {
                backArrow: true,
                title: 'profile.ChildProfile'
              }
            },
            {
              path: 'profile/premium',
              name: 'PerfilPremium',
              component: load('PerfilPremium'),
              meta: {
                backArrow: true,
                title: 'profile.premium'
              }
            },
            {
              path: 'profile/termos-de-uso',
              name: 'PerfilTermos',
              component: load('PerfilTermos'),
              meta: {
                backArrow: true,
                title: 'text.termsOfUse'
              }
            },
            {
              path: 'profile/politica-de-privacidade',
              name: 'PerfilPolitica',
              component: load('PerfilPolitica'),
              meta: {
                backArrow: true,
                title: 'text.privacyPolicy'
              }
            },
            {
              path: 'profile/faq',
              name: 'PerfilFaq',
              component: load('PerfilFaq'),
              meta: {
                backArrow: true,
                title: 'profile.faq'
              }
            }
          ]
        }
      ]
    },

    {
      path: '*',
      redirect: { name: 'login' },
      beforeEnter: multiguard([alreadyLoggedIn])
    }
  ]
});

router.beforeEach((to, from, next) => {
  bus.$emit('loading', true);
  document.querySelector('body').classList.remove(from.name);
  document.querySelector('body').classList.add(to.name);
  next();
});

export default router;
